import { useState, useCallback } from 'react';

export const useForm = (initalState = {}) => {
  const [fields, setFields] = useState(initalState);
  const [errors, setErrors] = useState({});

  const resetError = useCallback(
    (field) => {
      const nextErrors = { ...errors };
      delete nextErrors[field];
      setErrors(nextErrors);
    },
    [errors, setErrors]
  );

  const setValue = useCallback(
    (value, field) => {
      if (errors[field]) resetError(field);
      setFields({ ...fields, [field]: value });
    },
    [errors, resetError, setFields, fields]
  );

  const resetForm = useCallback(() => {
    setFields(initalState);
  }, [setFields, initalState]);

  const hasError = () => !!Object.keys(errors).find((fieldName) => !!errors[fieldName]);

  return {
    fields,
    errors,
    hasError: hasError(),
    setValue,
    setErrors,
    resetError,
    resetForm,
  };
};
